import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

// Import helpers
import { TAGS_TYPES, isNextText } from 'helpers/tags';

// Import styles
import { MetadataLists, List, ListItem } from './styles';

const { ICON } = TAGS_TYPES;

const ProductMetadata = ({ metadataLists = [] }) => {
	const metadata = metadataLists?.filter((list) => list.length);

	if (!metadata?.length) return null;

	return (
		<MetadataLists>
			{metadata.map((list, index) => (
				<List key={index}>
					{list.map(({ type, value }, i, arr) => (
						<ListItem
							key={value}
							modifiers={type}
							isNextText={isNextText(arr[i + 1])}
						>
							{type === ICON ? (
								<img src={value} alt={type} loading="lazy" />
							) : (
								<span>{value}</span>
							)}
						</ListItem>
					))}
				</List>
			))}
		</MetadataLists>
	);
};

ProductMetadata.propTypes = {
	metadataLists: arrayOf(arrayOf(shape({ type: string, value: string })))
};

export default ProductMetadata;
